export class ErrorHandlingModel {
  message: string;
  errors: string[];
  errorsInHTML = '';
  data: any;
}
